import React from 'react';

export const NoSmokingIcon = ({
  width = '24',
  height = '24',
  fill = '#0F2664',
}) => {
  return (
    <div className="feature">
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" stroke="black" strokeWidth="0.7" />
        <path
          d="M15.9058 14.9521C16.0989 14.9523 16.2554 15.1085 16.2554 15.3017V15.7314L15.6216 15.0976C15.685 15.0094 15.7887 14.9521 15.9058 14.9521Z"
          fill={fill}
        />
        <path
          d="M18.0676 15.3015V15.7339"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
        />
        <path
          d="M15.9053 12.9662C15.9053 12.1014 16.1893 9.50676 13.7431 9.50676C11.2969 9.50676 10.7162 8.02655 10.7162 6.91216C10.7162 5.79778 11.5811 4.75 13.7432 4.75"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
        />
        <path
          d="M18.0674 12.9661C18.0674 11.6689 18.4712 7.94426 15.4729 7.34459C13.3108 6.91216 15.473 5.61486 16.7705 4.75"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
        />
        <path
          d="M3.5 14.696H13.4459"
          stroke={fill}
          strokeWidth="0.7"
          strokeLinecap="round"
        />
        <path
          d="M18.5 5.5L5.50002 18.4998"
          stroke="black"
          strokeWidth="0.7"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};
